/**
 * Shared classNames repeated character-for-character across the standalone
 * marketing pages (Platform/Lighthouse/Studio/Console/Trust/Home/Careers/...).
 * These pages differ too much in section structure to share one layout
 * component, but the section "eyebrow" label and the plain bordered card
 * are the same treatment everywhere — pulled out here so a future tweak
 * only needs one edit instead of N.
 */
export const eyebrowClass =
  'font-mono text-xs font-semibold uppercase tracking-widest text-primary';
export const cardClass = 'rounded-lg border bg-card p-5';
